import { TurnosService } from './src/services/turnos.services';
export const turnosService = new TurnosService();
export default turnosService;
